package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordSignSymptomSeverity
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordSignSymptomState

@Serializable
open class MedicalRecordSignSymptom(var id: String? = null){
	var recordId: String? = null
	var signSymptomId: String? = null
	var severity: MedicalRecordSignSymptomSeverity? = null
	var state: MedicalRecordSignSymptomState? = null
	var relievedByFactorId: String? = null
	var triggeredWorsenedByFactorId: String? = null
	var isChiefComplaint: Byte? = null
	var order: Int? = null
	var lastSignSymptomId: String? = null
	var isDeleted: Boolean? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as MedicalRecordSignSymptom
		if (id != other.id) return false
		if (recordId != other.recordId) return false
		if (signSymptomId != other.signSymptomId) return false
		if (severity != other.severity) return false
		if (state != other.state) return false
		if (relievedByFactorId != other.relievedByFactorId) return false
		if (triggeredWorsenedByFactorId != other.triggeredWorsenedByFactorId) return false
		if (isChiefComplaint != other.isChiefComplaint) return false
		if (order != other.order) return false
		if (lastSignSymptomId != other.lastSignSymptomId) return false
		if (isDeleted != other.isDeleted) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (recordId?.hashCode() ?: 0)
		result = 31 * result + (signSymptomId?.hashCode() ?: 0)
		result = 31 * result + (severity?.hashCode() ?: 0)
		result = 31 * result + (state?.hashCode() ?: 0)
		result = 31 * result + (relievedByFactorId?.hashCode() ?: 0)
		result = 31 * result + (triggeredWorsenedByFactorId?.hashCode() ?: 0)
		result = 31 * result + (isChiefComplaint?.hashCode() ?: 0)
		result = 31 * result + (order?.hashCode() ?: 0)
		result = 31 * result + (lastSignSymptomId?.hashCode() ?: 0)
		result = 31 * result + (isDeleted?.hashCode() ?: 0)
		return result
	}

}
